<template>
  <b-container fluid id="main-container">
    <b-row>
      <b-col xs=12 class='no-padding'>
        <div class="instruction-section">
          <p v-if="$store.getters.language === 'SLO'" class='instruction-section-title'>{{model_name_slo}}</p>
          <p v-else class='instruction-section-title'>{{model_name}}</p>
          <p class='instruction-section-text' v-if="$store.getters.language === 'SLO'"> Besede so privzeto razvrščene glede na JSD K5 mero (večja vrednost pomeni večji semantični premik med dvema časovnima obdobjema). Če je časovnih obdobij več kot dve, so besede privzeto razvrščene glede na JSD K5 All (semantični premik med prvim in zadnjim obdobjem). JSD K5 Avg meri povprečni semantični premik preko vseh zaporednih časovnih obdobij. Kliknite na posamezno besedo za prikaz podrobnosti.</p>
          <p class='instruction-section-text' v-else> The words are by default sorted according to the JSD K5 semantic change score (bigger number indicates bigger change in word usage across two time periods). If there are more than two time periods, the default sorting is by JSD K5 All (semantic change between first and last time period). JSD K5 Avg measures average change across all consecutive time periods. Click on a specific word to get details.</p>
          <img id='rsdo-logo' v-bind:src="require('../assets/rsdo_logo.png')" alt="rsdo logo">
        </div>
      </b-col>
    </b-row>
   <b-form-group
    label-size="sm"
    class="mb-0"
  >
    <b-input v-if="$store.getters.language === 'SLO'" class="search-shift-input" id="search-shift-input" placeholder="Iskana beseda"></b-input>
    <b-input v-else class="search-shift-input" id="search-shift-input" placeholder="Search word"></b-input>
    <b-button v-if="$store.getters.language === 'SLO'" class="search-shift-button" pill v-on:click="searchTable" id="button-shift" type="button" variant="dark">Išči</b-button>
    <b-button v-else class="search-shift-button" pill v-on:click="searchTable" id="button-shift" type="button" variant="dark">Search</b-button>
    <b-button v-if="$store.getters.language === 'SLO'" class="clear-button" pill v-on:click="clearTable" id="button-shift" type="button" variant="dark">Počisti</b-button>
    <b-button v-else class="clear-button" pill v-on:click="clearTable" id="button-shift" type="button" variant="dark">Clear</b-button>
  </b-form-group>
  <hr />
    <b-table striped bordered hover 
      ref="scTable"
      id="semantic-change-table"
      :items="items" 
      :fields="fields" 
      :sort-by.sync="sortBy"
      :sort-desc="true"
      responsive="sm" 
      :per-page="perPage"
      :current-page="currentPage"
      @row-clicked="visualizeWord"> 
    </b-table>
    <div id="tableLoadSpinner">
      <b-spinner v-show="loading" type="grow" label="Loading..."></b-spinner>
    </div>

    <b-pagination
      id="semantic-change-pagination"
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      aria-controls="semantic-change-table">    
   </b-pagination>
   <img id='rsdo-footer' v-bind:src="require('../assets/rsdo_footer.png')" alt="rsdo logo">
   <a v-if="$store.getters.language === 'SLO'" id='rsdo-footer-git' v-bind:href=$store.getters.model_git target="_blank">Link do Github repozitorija</a>
   <a v-else id='rsdo-footer-git' v-bind:href=model_git target="_blank">Link to the Github repository</a>
  </b-container>
</template>

<script>
export default {
  name: "SemanticShiftTable",
  components: {},
  mounted() {
    this.model_id = this.$route.params['model_id'];
    this.fetchData()
  },
  data() {
    return {
      perPage: 100,
      currentPage: 1,
      sortBy: 'JSD K5 All',
      fields: [],
      items: [],
      searchWord: '',
      model_name: '',
      model_name_slo: '',
      model_git: '',
      loading:true,
    };
  },
  computed: {
    rows() {
      return this.items.length
    },
    language() {
      return this.$store.getters.language
    }
  },
  methods: {
    fetchData() {
      this.$http.get(this.$hostname + '/api/model/' + this.model_id + '/get')
      .then(response => { 
        this.items = response.data.model_reponse.items
        this.model_name = response.data.model_info.name
        this.model_name_slo = response.data.model_info.name_slo
        this.model_git = response.data.model_info.git
        this.$store.dispatch('save_model_id', this.model_id)
        this.$store.dispatch('save_model_name', this.model_name)
        this.$store.dispatch('save_model_name_slo', this.model_name_slo)
        this.$store.dispatch('save_model_git', this.model_git)
        for (var i = 0; i < response.data.model_reponse.columns.length; i++) {
          var c_name = response.data.model_reponse.columns[i]
          if (c_name === 'word') {
            c_name = 'Word/Beseda'
          } 
          this.fields.push({ key: response.data.model_reponse.columns[i], label: c_name, sortable: true},);  
        }
        this.loading = false
        var footerheight = document.getElementById('footer-container').offsetHeight;
        document.getElementById('app').style.paddingBottom = footerheight + 'px';
      })
      .catch(error => {
        console.error(error);
      });
    },
    visualizeWord(record, index) {
      console.log(record['word'], index); // This will be the item data for the row
      this.$router.push({
        name: 'semanticshiftvisualization',
        params: {
          word: record['word'],
          model_id: this.model_id
        }
      })
    },
    searchTable() {
      this.searchWord = document.getElementById('search-shift-input').value
      this.$http.get(this.$hostname + '/api/model/' + this.model_id + '/get', { params: { filter: this.searchWord } })
      .then(response => { 
        this.items = response.data.model_reponse.items
        for (var i = 0; i < response.data.model_reponse.columns.length; i++) {
            this.fields.push({ key: response.data.model_reponse.columns[i], label: response.data.model_reponse.columns[i], sortable: true},);  
        }
        console.log('Search request successful')
      })
      .catch(error => {
        console.error(error);
      });
    },
    clearTable() {
      this.$http.get(this.$hostname + '/api/model/' + this.model_id + '/get', { params: { filter: '' } })
      .then(response => { 
        this.items = response.data.model_reponse.items
        for (var i = 0; i < response.data.model_reponse.columns.length; i++) {
            this.fields.push({ key: response.data.model_reponse.columns[i], label: response.data.model_reponse.columns[i], sortable: true},);  
        }
        console.log('Clear request successful')
      })
      .catch(error => {
        console.error(error);
      });
    }
  },
}
</script>

<style lang="scss">
thead, tbody, tfoot, tr, td, th {
  text-align: left;
  width: 100px;
  vertical-align: middle;
  cursor: pointer;
}
.search-shift-input{
  float: left;
  width: 50%;
}
.search-shift-button{
  float: left;
  width: 24%;
  margin-left: 2% !important;
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}
.clear-button{
  float: left;
  width: 23%;
  margin-left: 1% !important;
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}

.instruction-section-title {
  text-align: center;
  margin-top: 10px;
  padding-top: 0px;
  padding-bottom: 0px;
  margin-bottom: 0px;
  font-size: 16px;
  font-weight: 500;
  text-transform: uppercase;
  color: #fff;
}
.instruction-section {
  padding: 20px;
  display: block;
  background-color: #4F6675;
  margin-bottom: 30px;
}

.instruction-section-text {
  text-align: center;
  margin: 10px;
  color: #fff;
  font-size: 14px;
  font-weight: 300;
}

#button-shift {
  background-color: #4F6675;
  border: #4F6675;
}

#semantic-change-table {
  color: #4F6675;
}

#semantic-change-pagination {

  .page-item.active .page-link {
    z-index: 3;
    color: #fff;
    background-color: #4F6675;
    border-color: #4F6675;
  }

  .page-link {
    color: #4F6675;
  }
}

#tableLoadSpinner {
  text-align: center;
  margin-top: 16px;
  margin-bottom: 16px;
}

.spinner-grow {
  background-color: #4F6675 !important;
}

#rsdo-logo {
  text-align: center;
  margin: auto;
  display: block;
  width: 50px;
}

#rsdo-footer {
  text-align: center;
  margin: auto;
  display: block;
  width: 50%;
}

@media (max-width: 1200px) {
  #rsdo-footer {
      width: 70%;
  }
}

@media (max-width: 1024px) {
  #rsdo-footer {
      width: 95%;
  }
}

#rsdo-footer-git {
  text-align: center;
  margin: auto;
  color: #4F6675;
  display: block;
  padding-top: 10px;
  padding-bottom: 10px;
}


</style>